import { AlertsTypes, NotificationsTypes } from './types';
import { createRequestReducer } from '@fullstory/redux-util';
import { AlertsResponse, AlertNotificationsResponse } from '@fullstory/client-api';
import { FetchAlertDataResponse } from '@fullstory/proto/fs/services/amber';
import { combineReducers } from '@fullstory/redux-util/utils/combineReducers';
import { metricAlertsReducer } from '../metricAlerts';

const alerts = createRequestReducer<AlertsResponse>()(
  AlertsTypes.FetchAlertsRequest,
  AlertsTypes.FetchAlertsSuccess,
  AlertsTypes.FetchAlertsFailure,
);

const alertData = createRequestReducer<FetchAlertDataResponse>()(
  AlertsTypes.FetchAlertDataRequest,
  AlertsTypes.FetchAlertDataSuccess,
  AlertsTypes.FetchAlertDataFailure,
);

const notifications = createRequestReducer<AlertNotificationsResponse>()(
  NotificationsTypes.FetchAlertNotificationsRequest,
  NotificationsTypes.FetchAlertNotificationsSuccess,
  NotificationsTypes.FetchAlertNotificationsFailure,
);

const alertsOverlay = createRequestReducer<AlertsResponse>()(
  AlertsTypes.OverlayFetchAlertsRequest,
  AlertsTypes.OverlayFetchAlertsSuccess,
  AlertsTypes.OverlayFetchAlertsFailure,
);

const notificationsOverlay = createRequestReducer<AlertNotificationsResponse>()(
  NotificationsTypes.OverlayFetchAlertNotificationsRequest,
  NotificationsTypes.OverlayFetchAlertNotificationsSuccess,
  NotificationsTypes.OverlayFetchAlertNotificationsFailure,
);

type AlertsReducerState = {
  alerts: ReturnType<typeof alerts>;
  alertsOverlay: ReturnType<typeof alertsOverlay>;
  alertData: ReturnType<typeof alertData>;
  notifications: ReturnType<typeof notifications>;
  notificationsOverlay: ReturnType<typeof notificationsOverlay>;
  metricAlerts: ReturnType<typeof metricAlertsReducer>;
};

export const alertsReducer = combineReducers<AlertsReducerState>({
  alerts,
  alertsOverlay,
  alertData,
  notifications,
  notificationsOverlay,
  metricAlerts: metricAlertsReducer,
});
